/**
 * Used for derivative products, such as options
 * tag: 203
 * @readonly
 * @enum {number} (int)
 */
export enum CoveredOrUncovered {
  /** Covered */
  Covered = 0,
  /** Uncovered */
  Uncovered = 1,
}
